(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;

    const modal = imagesWrapper.closest('product-modal');

    // Clicking anywhere in the content area closes the modal...
    imagesWrapper.addEventListener('click', () => {
      if (modal) modal.hide();
    });

    // ...except clicking the image itself, which toggles zoom
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');
    images.forEach(el => {
      let originX = 50, originY = 50;

      // pointerdown fires for both mouse and touch before click, capturing tap position
      el.addEventListener('pointerdown', (e) => {
        const rect = el.getBoundingClientRect();
        originX = ((e.clientX - rect.left) / rect.width) * 100;
        originY = ((e.clientY - rect.top) / rect.height) * 100;
      }, { passive: true });

      el.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!imagesWrapper.classList.contains('zoom')) {
          el.style.transformOrigin = `${originX}% ${originY}%`;
        }
        imagesWrapper.classList.toggle('zoom');
      });
    });
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
  });

  initProductAccordion();
  initZoomImage();
})();
